import { render } from "./AddForeignEmployee.vue?vue&type=template&id=70b8fa44"
import script from "./AddForeignEmployee.vue?vue&type=script&lang=js"
export * from "./AddForeignEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__